import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/styles.scss';
import "@fortawesome/fontawesome-free/css/all.css";
import "./script.js";
import App from './App.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals